import { Directive, ElementRef } from '@angular/core';

@Directive({
	selector: '[replaceSelectIcon]',
})
export class SelectIconDirective {
	private readonly observer: MutationObserver;

	constructor(private readonly el: ElementRef) {
		const node = this.el.nativeElement;

		this.observer = new MutationObserver(() => {
			this.replaceArrow();
		});

		this.observer.observe(node, {
			childList: true,
		});
	}

	private replaceArrow(): void {
		const selectIcon: HTMLElement = this.el.nativeElement.shadowRoot.querySelector('.select-icon');

		if (selectIcon !== null) {
			selectIcon.setAttribute('style', 'display: none !important');
			const selectText: HTMLElement = this.el.nativeElement.shadowRoot.querySelector('.select-text');
			if (selectText !== null) {
				const icon = document.createElement('ion-icon');
				icon.setAttribute('src', './assets/icons/arrow-small-down.svg');
				icon.setAttribute('style', 'margin-left: 10px; position: relative; top: 5px;');
				selectText.appendChild(icon);
			}
			const selectPlaceholder: HTMLElement =
				this.el.nativeElement.shadowRoot.querySelector('.select-placeholder');
			if (selectPlaceholder !== null) {
				selectPlaceholder.setAttribute('style', 'opacity: 1; color: #999 !important');
			}
		} else return;

		this.observer.disconnect();
	}
}
